// extracted by mini-css-extract-plugin
module.exports = {"product-search-result-item-label-list__container":"ProductSearchResultItemLabelList_product-search-result-item-label-list__container__oJHwy"};